// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/phrasing_fonts.scss
// module id = 49
// module chunks = 0